document.addEventListener("DOMContentLoaded", function () {
  var LICENSE_KEY = window.THEME_LICENSE_KEY;

  // simple validation: must exist and be long enough
  if (!LICENSE_KEY || LICENSE_KEY.length < 16) {
    document.documentElement.innerHTML = `
      <html>
        <head>
          <title>Theme Activation Required</title>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <style>
            * { box-sizing: border-box; }

            body {
              margin: 0;
              min-height: 100vh;
              background: linear-gradient(135deg, #020617, #020617);
              font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
              color: #e5e7eb;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 20px;
            }

            .lock-card {
              max-width: 520px;
              width: 100%;
              background: #020617;
              border: 1px solid #1e293b;
              border-radius: 16px;
              padding: 32px;
              text-align: center;
              box-shadow: 0 20px 60px rgba(0,0,0,0.6);
            }

            .lock-badge {
              display: inline-block;
              background: #020617;
              border: 1px solid #334155;
              color: #38bdf8;
              padding: 6px 12px;
              border-radius: 999px;
              font-size: 12px;
              margin-bottom: 20px;
            }

            h1 {
              font-size: 28px;
              margin: 0 0 12px;
              color: #f8fafc;
            }

            p {
              font-size: 16px;
              line-height: 1.6;
              color: #cbd5f5;
              margin-bottom: 24px;
            }

            .lock-note {
              font-size: 14px;
              color: #94a3b8;
            }

            @media (max-width: 480px) {
              h1 { font-size: 22px; }
              p { font-size: 15px; }
            }
          </style>
        </head>
        <body>
          <div class="lock-card">
            <div class="lock-badge">Theme Activation Required</div>
            <h1>Unlicensed Theme Detected</h1>
            <p>
              This Shopify theme requires a valid license key to operate.
              Please activate the theme to continue using this store layout.
            </p>
            <div class="lock-note">
              Contact the theme developer to obtain a valid license key.
            </div>
          </div>
        </body>
      </html>
    `;
  }
});
